// test885
(885 && 0);
